// extracted by mini-css-extract-plugin
export default {"card":"card__398cd854","row":"row__398cd854","group":"group__398cd854","label":"label__398cd854","fixed":"fixed__398cd854","value":"value__398cd854"};